<template>
    <div class="bg-white m-6 p-12 rounded-lg flex flex-col justify-center items-center gap-3">
        <!-- タイトルと説明部分 -->
        <div class="py-8 flex flex-col justify-center items-center gap-4">
          <div class="text-center text-main text-2xl font-semibold leading-8 break-words">
            招待をお待ちください
          </div>
          <div class="text-center text-main text-sm font-light leading-5 break-words">
            YouTubeチャンネルオーナーの方は、チャンネルの登録を進めてください。<br/><br/>
            編集者として参加する場合は、チャンネルオーナーからの招待が必要となります。<br/>
            招待が届くと通知が表示され、編集者としてチャンネルに参加できるようになります。
          </div>
        </div>

        <!-- ボタン -->
        <div class="flex flex-col items-center justify-center">
          <router-link to="/channel-creation" class="btn-secondary btn-lg text-main text-center whitespace-nowrap leading-6">チャンネル登録に進む</router-link>
        </div>
    </div>
</template>

<script setup>
</script>
